import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import { Switch, Route, Redirect } from "react-router-dom";
// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { pushBottomPanel, pushCampaign } from "../actions/dashboard";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import Header from "components/Header/Header1.jsx";
import Footer from "components/Footer/Footer.jsx";
import Sidebar from "components/Sidebar/Sidebar.jsx";

import dashboardRoutes from "routes/dashboardx.jsx";
import dashboardRoutesGuest from "routes/dashboardGuest.jsx";
import dashboardRoutesAdmin from "routes/dashboardxAdmin.jsx";
import dashboardRoutesExternal from "routes/dashboardExternal.jsx";
import dashboardRoutesAdminSibernetik from "routes/dashboardxAdminSibernetik.jsx";

import appStyle from "assets/jss/material-dashboard-pro-react/layouts/dashboardStyle.jsx";

import image from "assets/img/sidebar-4.jpg";
import logo from "assets/img/logo-white.svg";

import BlockUi from "react-block-ui";
import "react-block-ui/style.css";

import Rightpanel from "./Rightpanel";
import Bottompanel from "./Bottompanel";
import Leftpanel from "./Leftpanel";
import Campaign from "./Campaign";

var ps;

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.toggleBlocking = this.toggleBlocking.bind(this);
    this.state = {
      mobileOpen: false,
      miniActive: false,
      token: localStorage.getItem("token"),
      blocking: this.props.blocking,
      switchRoute: null,
      top: false,
      left: false,
      bottom: false,
      logo: localStorage.getItem("company_img")
    };
    this.resizeFunction = this.resizeFunction.bind(this);
  }

  toggleDrawer = (side, open) => () => {
    this.setState({
      [side]: open
    });
  };

  toggleBlocking() {
    this.setState({ blocking: !this.state.blocking });
  }

  UNSAFE_componentWillMount() {
    this.setState({ logo: localStorage.getItem("company_img") });
    if (this.state.token == null) {
      this.props.history.push("pages/login");
    }
  }

  componentDidMount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(this.refs.mainPanel, {
        suppressScrollX: true,
        suppressScrollY: false
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", this.resizeFunction);
  }
  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
    }
    window.removeEventListener("resize", this.resizeFunction);
  }
  componentDidUpdate(e) {
    if (e.history.location.pathname !== e.location.pathname) {
      this.refs.mainPanel.scrollTop = 0;
      if (this.state.mobileOpen) {
        this.setState({ mobileOpen: false });
      }
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.location.pathname !== "/portal") {
      this.props.pushBottomPanel(false);
    }
    // if (this.props.location.pathname == "/portal") {
    //   this.props.pushCampaign(true);
    // }
    this.setState({
      token: nextProps.token,
      blocking: nextProps.blocking,
      right: nextProps.rightPanel,
      campaign: nextProps.campaign
    });
  }

  handleDrawerToggle = () => {
    this.setState({ mobileOpen: !this.state.mobileOpen });
  };
  getRoute() {
    //return this.props.location.pathname !== "/maps/full-screen-maps";
    return this.props.location.pathname !== "/portal";
  }
  sidebarMinimize() {
    this.setState({ miniActive: !this.state.miniActive });
  }
  resizeFunction() {
    if (window.innerWidth >= 960) {
      this.setState({ mobileOpen: false });
    }
  }

  routnya = () => {
    if (localStorage.getItem("userlevel") === "2") {
      //this.setState({ routnya: dashboardRoutesAdminSibernetik });
      return dashboardRoutesAdmin;
    } else {
      if (localStorage.getItem("userlevel") == 2) {
        //this.setState({ routnya: dashboardRoutesAdmin });
        return dashboardRoutesAdmin;
      } else if (localStorage.getItem("userlevel") == 3) {
        return dashboardRoutesGuest;
      } else if (localStorage.getItem("userlevel") == 5) {
        return dashboardRoutesExternal;
      } else { 
        //this.setState({ routnya: dashboardRoutes });
        return dashboardRoutes;
      }
    }
  };

  switchnya = () => {
    let a;
    if (localStorage.getItem("userlevel") === "2") {
      a = dashboardRoutesAdmin;
    } else {
      if (localStorage.getItem("userlevel") == 2) {
        a = dashboardRoutesAdmin;
      } else if (localStorage.getItem("userlevel") == 3) {
        a = dashboardRoutesGuest;
      } else if (localStorage.getItem("userlevel") == 5) {
        return dashboardRoutesExternal;
      } else {
        a = dashboardRoutes;
      }
    }
    return (
      <Switch>
        {a.map((prop, key) => {
          if (prop.redirect) {
            return <Redirect from={prop.path} to={prop.pathTo} key={key} />;
          } else if (prop.collapse) {
            return prop.views.map((prop, key) => {
              return (
                <Route path={prop.path} component={prop.component} key={key} />
              );
            });
          } else if (prop.cctv) {
            return prop.views.map((prop, key) => {
              return (
                <Route path={prop.path} component={prop.component} key={key} />
              );
            });
          } else {
            return (
              <Route path={prop.path} component={prop.component} key={key} />
            );
          }
        })}
      </Switch>
    );
  };

  render() {
    const { classes, ...rest } = this.props;
    const mainPanel =
      classes.mainPanel +
      " " +
      cx({
        [classes.mainPanelSidebarMini]: this.state.miniActive,
        [classes.mainPanelWithPerfectScrollbar]:
          navigator.platform.indexOf("Win") > -1
      });
    return (
      <BlockUi tag="div" blocking={this.state.blocking} message="Please wait">
        <div className={classes.wrapper}>
          {/* <Sidebar
            routes={this.routnya()}
            logoText={"GeomTech"}
            logo={this.state.logo}
            image={image}
            handleDrawerToggle={this.handleDrawerToggle}
            open={this.state.mobileOpen}
            color="red"
            bgColor="black"
            miniActive={this.state.miniActive}
            {...rest}
          /> */}

          <div className={mainPanel} ref="mainPanel">
            <Header
              sidebarMinimize={this.sidebarMinimize.bind(this)}
              miniActive={this.state.miniActive}
              routes={this.routnya()}
              handleDrawerToggle={this.handleDrawerToggle}
              {...rest}
            />
            {/* On the /maps/full-screen-maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}
            {this.getRoute() ? (
              <div className={classes.content}>
                <div className={classes.container}>{this.switchnya()}</div>
              </div>
            ) : (
              <div className={classes.map}>{this.switchnya()}</div>
            )}
            {this.getRoute() ? <Footer fluid /> : null}
          </div>
          <Rightpanel />
          <Leftpanel />
          <Bottompanel />
          <Campaign />
        </div>
      </BlockUi>
    );
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired,
  pushBottomPanel: PropTypes.bool,
  pushCampaign: PropTypes.bool
};

function mapStateToProps(state) {
  return {
    token: state.token,
    blocking: state.loader,
    rightPanel: state.rightPanel,
    campaign: state.campaign
  };
}

export default withStyles(appStyle)(
  withRouter(
    connect(
      mapStateToProps,
      { pushBottomPanel, pushCampaign }
    )(Dashboard)
  )
);
